export const navItemsData = [
  {
    path: "/",
    name: "Home",
  },
  {
    path: "/about",
    name: "About",
  },
  {
    path: "/history",
    name: "History",
  },
  {
    path: "/our-menu",
    name: "Our Menu",
  },
  {
    path: "/reservation",
    name: "Reservation",
  },
  {
    path: "/contact",
    name: "Contact",
  },
]
